// frontend/src/services/api.js
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const api = axios.create({
  baseURL: `${API_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Handle response errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth APIs
export const authAPI = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data),
  getMe: () => api.get('/auth/me'),
};

// Room APIs
export const roomAPI = {
  create: () => api.post('/rooms/create'),
  get: (roomId) => api.get(`/rooms/${roomId}`),
  checkExists: (roomId) => api.get(`/rooms/${roomId}/exists`),
};

// Leaderboard APIs
export const leaderboardAPI = {
  getTop: () => api.get('/leaderboard'),
  getUserRank: (userId) => api.get(`/leaderboard/user/${userId}`),
};

export default api;
